<div class="h-full flex flex-column bg-gray-50">
  
    <!-- Sticky Header -->
    <div class="surface-0 border-bottom-1 border-200 px-4 py-3 flex justify-content-between align-items-center shadow-1 z-1" style="position: sticky; top: 0;">
        <div class="flex align-items-center gap-3">
            <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" (onClick)="goBack()"></p-button>
            <div>
                <h1 class="text-xl font-semibold m-0 text-900">
                    {{ mode() === 'edit' ? 'Editar Movimiento de Stock' : 'Nuevo Movimiento de Stock' }}
                </h1>
                <p class="text-sm text-500 m-0 mt-1">Registra entradas, salidas, ajustes o bloqueos de inventario</p>
            </div>
        </div>
        <div class="flex gap-2">
            <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary" (onClick)="goBack()" [disabled]="isSaving()"></p-button>
            <p-button label="Guardar" icon="pi pi-check" (onClick)="save()" [loading]="isSaving()" [disabled]="loading()"></p-button>
        </div>
    </div>
  
    <!-- Main Content -->
    <div class="flex-1 p-4 overflow-y-auto">
        @if(loading()) {
            <div class="flex flex-column gap-4 max-w-full m-auto" style="max-width: 1400px; width: 100%;">
                <!-- Skeleton Bloque 1: Tipo de Operación -->
                <div class="surface-card p-4 border-round shadow-1">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <p-skeleton width="180px" height="1.5rem"></p-skeleton>
                        <p-skeleton width="90px" height="1.8rem" borderRadius="16px"></p-skeleton>
                    </div>
                    <p-skeleton width="100%" height="4.5rem" styleClass="border-round"></p-skeleton>
                </div>
  
                <!-- Skeleton Bloque 2: Descripción -->
                <div class="surface-card p-4 border-round shadow-1">
                    <p-skeleton width="200px" height="1.5rem" styleClass="mb-3"></p-skeleton>
                    <p-skeleton width="100%" height="3.5rem" styleClass="border-round"></p-skeleton>
                </div>
  
                <!-- Skeleton Bloque 3: Ítems Involucrados -->
                <div class="surface-card p-4 border-round shadow-1">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <p-skeleton width="180px" height="1.5rem"></p-skeleton>
                        <p-skeleton width="110px" height="2rem" borderRadius="6px"></p-skeleton>
                    </div>
                    <div class="flex flex-column gap-2">
                        <p-skeleton width="100%" height="2.5rem" styleClass="border-round"></p-skeleton>
                        <p-skeleton width="100%" height="3rem" styleClass="border-round"></p-skeleton>
                        <p-skeleton width="100%" height="3rem" styleClass="border-round"></p-skeleton>
                    </div>
                </div>
            </div>
        } @else {
            <form [formGroup]="form" class="flex flex-column gap-4 max-w-full m-auto" style="max-width: 1400px; width: 100%;">
      
                <!-- Bloque 0: Sucursal de Operación -->
                <div class="surface-card p-4 border-round shadow-1" *ngIf="!branchId() && mode() === 'create'">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <h2 class="text-lg font-medium m-0 text-900"><i class="pi pi-building mr-2 text-primary"></i>Sucursal de Operación</h2>
                    </div>
                    <div class="field mb-0">
                        <p-dropdown 
                            formControlName="branchId" 
                            [options]="localBranches()" 
                            optionLabel="name" 
                            optionValue="id"
                            placeholder="Seleccione la sucursal..." 
                            styleClass="w-full max-w-20rem">
                        </p-dropdown>
                    </div>
                </div>

                <!-- Bloque 1: Tipo de Movimiento -->
                <div class="surface-card p-4 border-round shadow-1">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <h2 class="text-lg font-medium m-0 text-900"><i class="pi pi-cog mr-2 text-primary"></i>1. Tipo de Operación</h2>
                        @if(form.get('type')?.value) {
                            <p-button [icon]="optionsCondensed() ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" 
                                      [label]="optionsCondensed() ? 'Cambiar Tipo' : 'Ocultar'" 
                                      [text]="true" 
                                      size="small"
                                      (onClick)="toggleOptions()">
                            </p-button>
                        }
                    </div>
      
                    <!-- Expanded view (Cards) -->
                    @if(!optionsCondensed() || !form.get('type')?.value) {
                        <div class="grid">
                            @for(type of movementTypes; track type.value) {
                                <div class="col-12 md:col-6 lg:col-4">
                                    <div class="premium-card-select p-3 border-round-xl border-1 cursor-pointer transition-all flex align-items-center gap-3"
                                         [class.active]="form.get('type')?.value === type.value"
                                         (click)="selectType(type.value)">
                                        <div class="type-icon-circle"
                                             [style.background]="form.get('type')?.value === type.value ? type.color : '#e2e8f0'"
                                             [style.boxShadow]="form.get('type')?.value === type.value ? '0 4px 10px -2px ' + type.color + '80' : 'none'">
                                            <i [class]="type.icon"
                                               [style.color]="form.get('type')?.value === type.value ? '#ffffff' : '#64748b'"
                                               style="font-size:1.2rem;"></i>
                                        </div>
                                        <div class="flex flex-column">
                                            <span class="font-bold text-sm" [class.text-primary]="form.get('type')?.value === type.value">{{ type.label }}</span>
                                            <small class="text-500 line-height-3 mt-1">{{ type.description }}</small>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        @if(form.get('type')?.invalid && form.get('type')?.touched) {
                            <small class="text-red-500 block mt-2">Debe seleccionar un tipo de operación.</small>
                        }
                    } 
                    <!-- Condensed view (Selected banner) -->
                    @else {
                        @if(getSelectedType(); as selected) {
                            <div class="flex align-items-center p-3 border-round border-1 border-primary" [ngClass]="selected.bg">
                                <div class="flex align-items-center justify-content-center border-round w-3rem h-3rem mr-3"
                                     [style.backgroundColor]="selected.color + '20'" [style.color]="selected.color">
                                    <i [class]="selected.icon" class="text-xl"></i>
                                </div>
                                <div>
                                    <span class="font-bold text-900 text-lg block mb-1">{{ selected.label }}</span>
                                    <span class="text-600">{{ selected.description }}</span>
                                </div>
                            </div>
                        }
                    }

                    @if (form.get('type')?.value === 'TRANSFER') {
                        <div class="field mt-3 mb-0">
                            <label for="destinationBranchId" class="font-medium text-900 block mb-2">Sucursal Destino <span class="text-red-500">*</span></label>
                            <p-dropdown id="destinationBranchId" formControlName="destinationBranchId" [options]="localBranches()" optionLabel="name" optionValue="id" placeholder="Seleccione sucursal destino" styleClass="w-full max-w-20rem" [filter]="true"></p-dropdown>
                            @if (form.get('destinationBranchId')?.invalid && form.get('destinationBranchId')?.touched) {
                                <small class="text-red-500 block mt-1">La sucursal destino es obligatoria para transferencias.</small>
                            }
                        </div>
                    }
                </div>
      
                <!-- Bloque 2: Detalles Generales -->
                <div class="surface-card p-4 border-round shadow-1">
                    <h2 class="text-lg font-medium m-0 mb-3 text-900"><i class="pi pi-align-left mr-2 text-primary"></i>2. Detalles y Referencia</h2>
                    
                    <div class="field mb-0">
                        <textarea pTextarea formControlName="description" rows="2" class="w-full" placeholder="Ingrese una descripción detallada del movimiento (Ej: Motivo del ajuste, número de remito, etc.)"></textarea>
                    </div>
                </div>
      
                <!-- Bloque 3: Artículos Involucrados -->
                <div class="surface-card p-4 border-round shadow-1">
                    <div class="flex justify-content-between align-items-center mb-3">
                        <div>
                            <h2 class="text-lg font-medium m-0 text-900"><i class="pi pi-box mr-2 text-primary"></i>3. Ítems Involucrados</h2>
                            @if(form.get('type')?.value === 'UNBLOCK') {
                                <small class="text-teal-600 font-medium block mt-1"><i class="pi pi-info-circle mr-1"></i>Mostrando únicamente artículos con stock inmovilizado / bloqueado</small>
                            }
                        </div>
                        <p-button label="Agregar Ítem" icon="pi pi-plus" size="small" [outlined]="true" (onClick)="addItemRow()" [disabled]="!form.get('type')?.value"></p-button>
                    </div>
      
                    @if(!form.get('type')?.value) {
                        <div class="p-5 border-round border-1 border-dashed border-300 text-center bg-gray-50 flex flex-column align-items-center justify-content-center gap-2">
                            <i class="pi pi-info-circle text-primary text-3xl mb-1"></i>
                            <span class="font-medium text-800 text-base">Seleccione un tipo de operación en el paso 1</span>
                            <span class="text-xs text-500 max-w-28rem">Elija Entrada, Salida, Ajuste, Bloqueo o Desbloqueo arriba para habilitar la grilla de artículos y sus validaciones específicas.</span>
                        </div>
                    } @else {
                        @if(errorMessage()) {
                            <div class="p-3 mb-3 border-round bg-red-50 text-red-700 border-1 border-red-200 flex align-items-center">
                                <i class="pi pi-exclamation-triangle mr-2 text-xl"></i>
                                <span>{{ errorMessage() }}</span>
                            </div>
                        }
          
                        <p-table [value]="itemsFormArray.controls" styleClass="p-datatable-sm p-datatable-striped" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    @if(form.get('type')?.value === 'IN') {
                                        <th style="width: 32%">Artículo</th>
                                        <th style="width: 8%">Cantidad</th>
                                        <th style="width: 12%">Nº Lote (Opc.)</th>
                                        <th style="width: 12%">F. Recepción</th>
                                        <th style="width: 12%">F. Vencimiento</th>
                                        <th style="width: 20%">Motivo específico (Opc.)</th>
                                        <th style="width: 4%"></th>
                                    } @else if(form.get('type')?.value === 'OUT' || form.get('type')?.value === 'BLOCK') {
                                        <th style="width: 34%">Artículo</th>
                                        <th style="width: 10%">{{ form.get('type')?.value === 'BLOCK' ? 'A Bloquear' : 'Cantidad' }}</th>
                                        <th style="width: 28%">Lote (FEFO / FIFO)</th>
                                        <th style="width: 24%">Motivo específico (Opc.)</th>
                                        <th style="width: 4%"></th>
                                    } @else if(form.get('type')?.value === 'UNBLOCK') {
                                        <th style="width: 42%">Artículo con Stock Bloqueado</th>
                                        <th style="width: 14%">A Desbloquear</th>
                                        <th style="width: 40%">Motivo / Justificación</th>
                                        <th style="width: 4%"></th>
                                    } @else {
                                        <th style="width: 42%">Artículo</th>
                                        <th style="width: 14%">Stock Final Físico</th>
                                        <th style="width: 40%">Motivo del Ajuste</th>
                                        <th style="width: 4%"></th>
                                    }
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-ctrl let-rowIndex="rowIndex">
                                <tr [formGroup]="ctrl">
                                    <td>
                                        <p-dropdown formControlName="itemId" [options]="filteredAvailableItems()" optionLabel="label" optionValue="value" 
                                                    [filter]="true" filterBy="name,internal_code,label" appendTo="body" placeholder="Seleccione un ítem..." 
                                                    styleClass="w-full"
                                                    [panelStyle]="{'min-width': '480px', 'max-width': '700px'}"
                                                    [virtualScroll]="true" [virtualScrollItemSize]="38"
                                                    [ngClass]="{'ng-invalid ng-dirty': invalidItems().has(ctrl.value.itemId) || (ctrl.get('itemId')?.invalid && ctrl.get('itemId')?.touched)}">
                                            <ng-template let-item pTemplate="item">
                                                <div class="flex align-items-center justify-content-between w-full py-1 gap-2">
                                                    <div class="flex align-items-center gap-2 overflow-hidden">
                                                        <span class="font-bold text-xs text-primary font-mono bg-blue-50 px-2 py-1 border-round border-1 border-blue-200 white-space-nowrap">
                                                            {{ item.internal_code || 'S/C' }}
                                                        </span>
                                                        <span class="font-medium text-800 text-sm text-overflow-ellipsis overflow-hidden white-space-nowrap" [title]="item.name">
                                                            {{ item.name }}
                                                        </span>
                                                    </div>
                                                    <div class="text-right white-space-nowrap ml-auto pl-2 flex-shrink-0">
                                                        @if(form.get('type')?.value === 'UNBLOCK') {
                                                            <span class="text-xs font-semibold px-2 py-1 border-round bg-teal-50 text-teal-700 border-1 border-teal-200">
                                                                Bloqueado: {{ item.blocked_stock }}
                                                            </span>
                                                        } @else {
                                                            <span class="text-xs font-medium px-2 py-1 border-round border-1" 
                                                                  [ngClass]="item.available_stock > 0 ? 'bg-green-50 text-green-700 border-green-200' : 'bg-gray-100 text-600 border-300'">
                                                                Disp: {{ item.available_stock }} | Total: {{ item.stock }}
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <ng-template let-selectedItem pTemplate="selectedItem">
                                                <div class="flex align-items-center gap-2 text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                                    <span class="font-bold text-xs text-primary font-mono bg-blue-50 px-1 border-round">
                                                        {{ selectedItem.internal_code || 'S/C' }}
                                                    </span>
                                                    <span class="text-sm font-medium text-900 text-overflow-ellipsis overflow-hidden">
                                                        {{ selectedItem.name }}
                                                    </span>
                                                </div>
                                            </ng-template>
                                        </p-dropdown>
                                    </td>
                                    <td>
                                        <p-inputNumber formControlName="quantity" [min]="0" styleClass="w-full"
                                                       [ngClass]="{'ng-invalid ng-dirty': invalidItems().has(ctrl.value.itemId) || (ctrl.get('quantity')?.invalid && ctrl.get('quantity')?.touched)}">
                                        </p-inputNumber>
                                    </td>
                                    @if(form.get('type')?.value === 'IN') {
                                        <td>
                                            <input pInputText formControlName="lot_number" placeholder="Ej: LOT-101" class="w-full" />
                                        </td>
                                        <td>
                                            <p-datepicker formControlName="reception_date" dateFormat="dd/mm/yy" appendTo="body" class="w-full" styleClass="w-full" [showClear]="false" placeholder="Fecha Recep."></p-datepicker>
                                        </td>
                                        <td>
                                            <p-datepicker formControlName="expiration_date" dateFormat="dd/mm/yy" appendTo="body" class="w-full" styleClass="w-full" [showClear]="true" placeholder="Sin vto."></p-datepicker>
                                        </td>
                                    } @else if(form.get('type')?.value === 'OUT' || form.get('type')?.value === 'BLOCK') {
                                        <td>
                                            <p-dropdown formControlName="lotId" [options]="rowLots()[rowIndex] || []" optionLabel="label" optionValue="value"
                                                        appendTo="body" placeholder="Automático (FEFO/FIFO)" [showClear]="true" styleClass="w-full">
                                            </p-dropdown>
                                            @if(rowFefoSuggestions()[rowIndex]; as fefo) {
                                                <div class="mt-1 flex align-items-center gap-1 text-xs cursor-pointer" [pTooltip]="fefo.explanation" tooltipPosition="top">
                                                    <p-tag [value]="fefo.strategy" [severity]="fefo.strategy === 'FEFO' ? 'info' : 'success'" styleClass="text-xs py-0 px-1"></p-tag>
                                                    <span class="text-600 white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 180px;">
                                                        {{ fefo.recommendedLot ? 'Prioriza Lote ' + fefo.recommendedLot.lot_number : 'Sin lotes activos' }}
                                                    </span>
                                                    <i class="pi pi-info-circle text-primary text-xs ml-auto"></i>
                                                </div>
                                            } @else {
                                                <small class="text-500 block mt-1">Dejar vacío para auto-asignación</small>
                                            }
                                        </td>
                                    }
                                    <td>
                                        <input pInputText formControlName="reason" class="w-full" [placeholder]="form.get('type')?.value === 'UNBLOCK' ? 'Motivo de liberación' : (form.get('type')?.value === 'ADJUSTMENT' ? 'Motivo del recuento' : 'Ej: Observación')" />
                                    </td>
                                    <td class="text-center">
                                        <p-button icon="pi pi-trash" severity="danger" [text]="true" [rounded]="true" (onClick)="removeItemRow(rowIndex)" [disabled]="itemsFormArray.length === 1"></p-button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7" class="text-center py-4 text-500">
                                        No hay ítems agregados. Haga clic en "Agregar Ítem".
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    }
                </div>
      
            </form>
        }
    </div>
</div>
